import { Button, Flex, Text } from '@chakra-ui/react'

export default function Paginator({
  page,
  totalPages,
  changePage
}: {
  page: number
  totalPages: number
  changePage: (page: number) => void
}) {
  return (
    <Flex justifyContent="center" alignItems="center" mt={4}>
      <Button
        colorScheme="magenta"
        size="sm"
        mr={2}
        disabled={page == 1}
        style={{ cursor: 'default' }}
        onClick={() => {
          changePage(page - 1)
        }}
      >
        <i className="lni lni-chevron-left"></i>
      </Button>
      <Text>
        Página {totalPages == 0 ? 0 : page} de {totalPages}
      </Text>
      <Button
        colorScheme="magenta"
        size="sm"
        ml={2}
        mr={2}
        disabled={page >= totalPages}
        style={{ cursor: 'default' }}
        onClick={() => {
          changePage(page + 1)
        }}
      >
        <i className="lni lni-chevron-right"></i>
      </Button>
    </Flex>
  )
}
